import { EmployeeFormData } from '../types/types'
import { convertData2JsonForm } from '../../../../shared/lib/convertData2JsonForm'
import { addEnumValBySchema } from '../../../../shared/lib/addEnumValBySchema'
import { injectComplianceFieldsIntoSchema } from '../utils/inject-compliance-fields'

// Маппинг полей формы на коды enum-ов
const fieldToEnumMap: Record<string, string> = {
  post_id: 'post',
  department_id: 'department',
  office_id: 'office',
  gender: 'gender',
  city_id: 'city_id',
  region_id: 'region_id',
  district_id: 'district_id',
  federal_district_id: 'federal_district_id',
  dismissal_reason_id: 'employee_dismissal_reason',
}

export const getEmployeeFormData = (data: any): EmployeeFormData | null => {
  if (!data) {
    return null
  }

  const { employee, fields, permissions, enums, events, files, compliance } = data
  const employeeId = employee?.id

  // Для новой карточки employee может быть пустым объектом
  if (!fields) {
    console.warn('getEmployeeFormData: fields отсутствуют', data)
    return null
  }

  // Конвертируем поля формы (fields может быть массивом FieldObject[] или FieldGroup[])
  const { resultObject, resultSchema } = convertData2JsonForm(fields)

  if (!resultSchema || !resultSchema.properties) {
    console.warn('getEmployeeFormData: resultSchema пустая', { fields, resultSchema })
    return null
  }

  // Fallback: если в employee есть phones, а в схеме нет — добавляем поле
  const employeeData = (employee || {}) as Record<string, unknown>
  const formDataObj = resultObject as Record<string, unknown>
  if (
    (Array.isArray(employeeData['phones']) && employeeData['phones'].length > 0) ||
    (formDataObj?.['phones'] !== undefined && formDataObj?.['phones'] !== null)
  ) {
    const schemaProps = resultSchema.properties as Record<string, unknown>
    if (!schemaProps['phones']) {
      schemaProps['phones'] = {
        title: 'Номера телефонов',
        type: 'string',
        format: 'phones',
        options: { disabled: true },
      }
      if (!resultSchema.groups) {
        resultSchema.groups = {}
      }
      // Добавляем phones в группу с fio (основные данные) или в первую группу
      const groupWithFio = Object.entries(resultSchema.groups).find(([, g]) =>
        (g as any)?.fields?.includes('fio'),
      )
      const targetGroup = groupWithFio
        ? resultSchema.groups[groupWithFio[0]]
        : resultSchema.groups[Object.keys(resultSchema.groups)[0]]
      if (targetGroup?.fields && !targetGroup.fields.includes('phones')) {
        targetGroup.fields.push('phones')
      }
      formDataObj['phones'] = employeeData['phones'] ?? formDataObj?.['phones'] ?? []
    }
  }

  injectComplianceFieldsIntoSchema(resultSchema, formDataObj, employeeId)

  // Добавляем enum значения в схему
  if (enums && resultSchema?.properties) {
    // Проходим по всем полям схемы
    Object.keys(resultSchema.properties).forEach(fieldName => {
      // Получаем код enum для этого поля
      const enumCode = fieldToEnumMap[fieldName] || fieldName

      // Проверяем, есть ли enum с таким кодом
      if (enums[enumCode] && Array.isArray(enums[enumCode]) && enums[enumCode].length > 0) {
        const enumValues = enums[enumCode]
        const oneOf = enumValues.map((item: any) => ({
          const: item.id,
          title: item.value,
        }))

        addEnumValBySchema(resultSchema, fieldName, oneOf, enumValues)
      }
    })
  }

  return {
    employee: employee || {},
    fields: fields, // Сохраняем исходные fields для использования в форме
    schema: resultSchema,
    formData: resultObject || {},
    permissions,
    enums,
    events: events || [],
    files: files || [],
    compliance: compliance || null,
  }
}
